export default function RogersAcceptanceFacilitiesSection() {
  return (
    <section id="facilities" className="bg-white py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Local Facilities</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">Passport Acceptance Facilities Near Rogers</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
          {[
            { name: "Rogers Post Office", address: "2020 W Oak St, Rogers, AR 72756", phone: "(479) 636-5940", type: "Post Office", note: "Appointment required for passport applications." },
            { name: "Benton County Clerk", address: "215 E Central Ave, Bentonville, AR 72712", phone: "(479) 271-1012", type: "County Clerk", note: "Serves Benton County including Rogers. Call ahead for availability." },
          ].map((f) => (
            <div key={f.name} className="bg-[#F7F8FA] rounded-lg p-6">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EEF2F8]"><i className="ri-government-line text-[#1A365D]"></i></div>
                <div><h3 className="font-bold text-[#1A365D] text-base">{f.name}</h3><span className="text-xs text-gray-500 bg-white px-2 py-0.5 rounded-full border border-gray-200">{f.type}</span></div>
              </div>
              <div className="space-y-2 text-sm">
                <div className="flex items-center gap-2 text-gray-600"><i className="ri-map-pin-line text-[#F6C344]"></i>{f.address}</div>
                <div className="flex items-center gap-2 text-gray-600"><i className="ri-phone-line text-[#F6C344]"></i>{f.phone}</div>
                <div className="flex items-center gap-2 text-gray-500"><i className="ri-information-line text-[#F6C344]"></i>{f.note}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}